import React from "react";
import {useEnsureTranslate} from "../../../shared-services/translate";
import {FarmyButton} from "../../../react-components/shared/SharedComponents";
import useWindowTools from "../../../react-hooks/useWindowTools";

const FreeDeliveryBanner = ({
    name,
    onClose = () => {},
    Content
  }) => {
  useEnsureTranslate();
  const {isMobile} = useWindowTools();

  return (
    <div
      className={`
      flex
      justify-content-center
      align-items-center
      text-color-white
      full-width
      full-height
      background-color-green
      overflow-hidden
      text-strong
      `}
      style={{
        zIndex: 1000,
        fontSize: (isMobile ? "12px" : "16px"),
        lineHeight: (isMobile ? "14px" : "18px")
      }}
    >
      <div
        className={`
        flex
        flex-direction-row
        align-items-center
        full-height
        full-width
        position-relative
        ${name === "FreeDeliveryBanner:Cart"
      ? "justify-content-center"
      : "justify-content-flex-end"}
        `}
        style={{padding: "8px 10px", maxWidth: "1160px"}}
      >
        <div className="flex flex-wrap-nowrap justify-content-center align-items-center">
          <Content/>
        </div>
        <FarmyButton
          color={"transparent"}
          className={`
            flex
            justify-content-center
            align-items-center
            border-none
            padding-0
            ${name === "FreeDeliveryBanner:Cart"
      ? " position-absolute"
      : null}
          `}
          style={{
            opacity: 0.4,
            height: "12px",
            width: "12px",
            marginLeft: "25px",
            right: (name === "FreeDeliveryBanner:Cart") ? "15px" : null
          }}
          onClick={onClose}>
          <img className={"full-height"} src={"/icons/thin-cross-white.svg"} alt={"close"}/>
        </FarmyButton>
      </div>
    </div>);
};

export default FreeDeliveryBanner;
